import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Scales } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Register() {
  const nav = useNavigate();
  const { register, loading } = useAuth();
  const [form, setForm] = useState({
    full_name: "",
    kanzlei_name: "",
    email: "",
    password: "",
  });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    try {
      await register(form);
      toast.success("Kanzlei eingerichtet");
      nav("/app/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registrierung fehlgeschlagen");
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="flex items-center justify-center p-8 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-md space-y-8" data-testid="register-form">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-8">
              <Scales weight="duotone" size={24} className="text-[#1A2238]" />
              <span className="font-serif text-xl">LexAuto</span>
            </Link>
            <p className="overline text-[#D32F2F] mb-3">Kanzlei einrichten</p>
            <h1 className="font-serif text-4xl tracking-tight">14 Tage kostenlos</h1>
            <p className="text-[#4B5563] mt-2 text-sm">Keine Kreditkarte nötig.</p>
          </div>
          <div className="space-y-4">
            <div>
              <Label className="overline text-[#4B5563]">Ihr Name</Label>
              <Input required value={form.full_name} onChange={e => set("full_name", e.target.value)} className="mt-2" placeholder="Dr. Max Müller" data-testid="register-fullname-input" />
            </div>
            <div>
              <Label className="overline text-[#4B5563]">Kanzlei</Label>
              <Input required value={form.kanzlei_name} onChange={e => set("kanzlei_name", e.target.value)} className="mt-2" placeholder="Kanzlei Müller &amp; Partner" data-testid="register-kanzlei-input" />
            </div>
            <div>
              <Label className="overline text-[#4B5563]">E-Mail</Label>
              <Input required type="email" value={form.email} onChange={e => set("email", e.target.value)} className="mt-2" placeholder="mueller@kanzlei.de" data-testid="register-email-input" />
            </div>
            <div>
              <Label className="overline text-[#4B5563]">Passwort</Label>
              <Input required type="password" minLength={6} value={form.password} onChange={e => set("password", e.target.value)} className="mt-2" placeholder="min. 6 Zeichen" data-testid="register-password-input" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-[#1A2238] hover:bg-[#2C3859]" data-testid="register-submit-btn">
            {loading ? "Einrichten..." : "Kostenlos einrichten"}
          </Button>
          <p className="text-sm text-[#4B5563] text-center">
            Bereits Kunde? <Link to="/login" className="text-[#1A2238] underline decoration-[#D32F2F]" data-testid="register-to-login-link">Anmelden</Link>
          </p>
        </form>
      </div>
      <div className="hidden lg:flex flex-col justify-between p-12 bg-[#1A2238] text-white relative overflow-hidden order-1 lg:order-2">
        <div />
        <div className="max-w-md">
          <p className="overline text-[#D32F2F] mb-4">Für deutsche Verkehrsrechtsanwälte</p>
          <h2 className="font-serif text-5xl leading-tight mb-6">Akten in <span className="italic">60 Sekunden</span> — nicht 60 Minuten.</h2>
          <ul className="space-y-3 text-white/80">
            <li className="flex gap-3"><span className="text-[#D32F2F]">—</span> KI analysiert Gutachten automatisch</li>
            <li className="flex gap-3"><span className="text-[#D32F2F]">—</span> Anspruchsschreiben in 47 Sekunden</li>
            <li className="flex gap-3"><span className="text-[#D32F2F]">—</span> RVG-konforme Bezifferung</li>
            <li className="flex gap-3"><span className="text-[#D32F2F]">—</span> OWi-Einspruch mit einem Klick</li>
          </ul>
        </div>
        <p className="text-xs text-white/40">DSGVO · Hosting in Deutschland</p>
      </div>
    </div>
  );
}
